export const SET_TITLE_PRIVATE_FUNCTIONS = "SET_TITLE_PRIVATE_FUNCTIONS";

// Sets private functions to title plugin
export const setTitlePrivateFunctions = (data) => ({
    type: "SET_TITLE_PRIVATE_FUNCTIONS",
    payload: data
});